/**
 * Safely scales all objects on a Fabric.js canvas from old dimensions to new ones.
 *
 * @param {fabric.Canvas} canvas - The Fabric.js canvas instance.
 * @param {number} oldW - Original canvas width stored in the JSON.
 * @param {number} oldH - Original canvas height stored in the JSON.
 * @param {number} newW - Current canvas width (e.g. responsive container).
 * @param {number} newH - Current canvas height.
 */
export function scaleLoadedObjects(canvas, oldW, oldH, newW, newH) {
    if (!canvas || !oldW || !oldH || !newW || !newH) return;

    const scaleX = newW / oldW;
    const scaleY = newH / oldH;

    canvas.getObjects().forEach((obj, index) => {
        // Avoid scaling multiple times
        if (obj.__scaled) return;
        obj.__scaled = true; // Prevent future re-scaling

        obj.scaleX *= scaleX;
        obj.scaleY *= scaleY;
        obj.left *= scaleX;
        obj.top *= scaleY;
        obj.setCoords();

        // Ensure visibility and prevent objects from going offscreen
        obj.visible = true;
        obj.opacity = 1;

        // Constrain objects to canvas bounds
        obj.left = Math.max(0, Math.min(newW - obj.width * obj.scaleX, obj.left));
        obj.top = Math.max(0, Math.min(newH - obj.height * obj.scaleY, obj.top));
    });

    canvas.requestRenderAll();
}
